import { render, staticRenderFns } from "./ChangeContractAudit.vue?vue&type=template&id=85d80fb0&scoped=true"
import script from "./ChangeContractAudit.vue?vue&type=script&lang=js"
export * from "./ChangeContractAudit.vue?vue&type=script&lang=js"
import style0 from "./ChangeContractAudit.vue?vue&type=style&index=0&id=85d80fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d80fb0",
  null
  
)

export default component.exports